import { api } from "../../api/axios";

/* =====================================================
   ADMIN DASHBOARD SERVICES
   (JWT Protected APIs)
===================================================== */

export const adminDashboardServices = {
  // getDashboardSummary: async (filter) => {
  //   const { data } = await api.get("/admin/dashboard/summary", {
  //     params: { filter },
  //   });
  //   return data.data;
  // },
  // getApplicationsAnalytics: async (filter) => {
  //   const { data } = await api.get("/admin/dashboard/applications-analytics", {
  //     params: { filter },
  //   });
  //   return data.data;
  // },
  // getPortfolioAnalytics: async (filter) => {
  //   const { data } = await api.get("/admin/dashboard/portfolio-analytics", {
  //     params: { filter },
  //   });
  //   return data.data;
  // },
  // getMessagesAnalytics: async (filter) => {
  //   const { data } = await api.get("/admin/dashboard/messages-analytics", {
  //     params: { filter },
  //   });
  //   return data.data;
  // },
  // getRecentMessages: async () => {
  //   const { data } = await api.get("/admin/dashboard/recent-messages");
  //   return data.data;
  // },
  // getRecentApplications: async () => {
  //   const { data } = await api.get("/admin/dashboard/recent-applications");
  //   return data.data;
  // },
  // getSystemStatus: async () => {
  //   const { data } = await api.get("/admin/dashboard/system-status");
  //   return data.data;
  // },
  getDashboardOverview: async () => {
    const { data } = await api.get("/admin/dashboard/overview");
    return data.data;
  },
  /* =====================================================
     MESSAGES MANAGEMENT
  ===================================================== */

  getMessages: async (params = {}) => {
    const response = await api.get("/admin/messages", {
      params,
    });

    return response.data;
  },

  getMessageById: async (id) => {
    const { data } = await api.get(`/admin/messages/${id}`);
    return data;
  },

  markMessageAsRead: async (id, isRead = true) => {
    const { data } = await api.patch(`/admin/messages/${id}/read`, { isRead });
    return data;
  },

  getUnreadMessagesCount: async () => {
    const { data } = await api.get("/admin/messages/unread-count");
    return data;
  },

  deleteMessage: async (id) => {
    const { data } = await api.delete(`/admin/messages/${id}`);
    return data;
  },


  /* =====================================================
     TESTIMONIALS MANAGEMENT
  ===================================================== */

  getTestimonials: async (params = {}) => {
    const { data } = await api.get("/admin/testimonial/alltestimonials", { params });
    return data;
  },

  createTestimonial: async (payload) => {
    const { data } = await api.post("/admin/testimonial", payload);
    return data;
  },

  updateTestimonial: async (id, payload) => {
    const { data } = await api.patch(`/admin/testimonial/${id}`, payload);
    return data;
  },

  deleteTestimonial: async (id) => {
    const { data } = await api.delete(`/admin/testimonial/${id}`);
    return data;
  },

  /* =====================================================
     LEADS MANAGEMENT
  ===================================================== */

  getLeads: async (params = {}) => {
    const { data } = await api.get("/admin/leads", { params });
    return data;
  },

  deleteLead: async (id) => {
    const { data } = await api.delete(`/admin/leads/${id}`);
    return data;
  },

  /* =====================================================
     JOBS / OPPORTUNITIES MANAGEMENT
  ===================================================== */

  getAllOpportunities: async (params = {}) => {
    const { data } = await api.get("/admin/opportunities", { params });
    return data;
  },

  createOpportunity: async (payload) => {
    const { data } = await api.post("/admin/opportunities", payload);
    return data;
  },

  updateOpportunity: async (id, payload) => {
    const { data } = await api.patch(`/admin/opportunities/${id}`, payload);
    return data;
  },

  deleteOpportunity: async (id) => {
    const { data } = await api.delete(`/admin/opportunities/${id}`);
    return data;
  },

  /* =====================================================
     APPLICATION MANAGEMENT
  ===================================================== */

  getApplications: async (params = {}) => {
    const { data } = await api.get("/admin/application", { params });
    return data;
  },

  deleteApplication: async (id) => {
    const { data } = await api.delete(`/admin/application/${id}`);
    return data;
  },

  updateApplicationStatus: async (id, payload) => {
    const { data } = await api.patch(`/admin/application/${id}/status`, payload);
    return data;
  },

  markApplicationAsViewed: async (id, isView = true) => {
    const { data } = await api.patch(`/admin/application/${id}/view`, { isView });
    return data;
  },

  getUnviewedApplicationsCount: async () => {
    const { data } = await api.get("/admin/application/unviewed-count");
    return data;
  },


  /* =====================================================
   INDUSTRY LEADERS MANAGEMENT
===================================================== */

  getIndustryLeaders: async (params = {}) => {
    const { data } = await api.get("/admin/industry-leaders", { params });
    return data;
  },

  createIndustryLeader: async (payload) => {
    const { data } = await api.post("/admin/industry-leaders", payload);
    return data;
  },

  updateIndustryLeader: async (id, payload) => {
    const { data } = await api.patch(`/admin/industry-leaders/${id}`, payload);
    return data;
  },

  deleteIndustryLeader: async (id) => {
    const { data } = await api.delete(`/admin/industry-leaders/${id}`);
    return data;
  },

  /* =====================================================
   PORTFOLIO PROJECTS MANAGEMENT
===================================================== */

  getPortfolioProjects: async (params = {}) => {
    const { data } = await api.get("/admin/portfolio/projects", { params });
    return data;
  },

  getPortfolioProjectById: async (id) => {
    const { data } = await api.get(`/admin/portfolio/projects/${id}`);
    return data;
  },

  createPortfolioProject: async (payload) => {
    const { data } = await api.post("/admin/portfolio/projects", payload);
    return data;
  },

  updatePortfolioProject: async (id, payload) => {
    const { data } = await api.patch(`/admin/portfolio/projects/${id}`, payload);
    return data;
  },

  deletePortfolioProject: async (id) => {
    const { data } = await api.delete(`/admin/portfolio/projects/${id}`);
    return data;
  },

  getPortfolioCategories: async () => {
    const { data } = await api.get("/admin/portfolio/projects/categories");
    return data;
  },

  restorePortfolioProject: async (id) => {
    return await api.patch(`/admin/portfolio/projects/${id}/restore`);
  },

  /* =====================================================
   PORTFOLIO TECH STACK MANAGEMENT
===================================================== */

  getTechStack: async (params = {}) => {
    const { data } = await api.get("/admin/portfolio/tech-stack", { params });
    return data;
  },

  getTechStackById: async (id) => {
    const { data } = await api.get(`/admin/portfolio/tech-stack/${id}`);
    return data;
  },

  createTechStack: async (payload) => {
    const { data } = await api.post("/admin/portfolio/tech-stack", payload);
    return data;
  },

  updateTechStack: async (id, payload) => {
    const { data } = await api.patch(`/admin/portfolio/tech-stack/${id}`, payload);
    return data;
  },

  deleteTechStack: async (id) => {
    const { data } = await api.delete(`/admin/portfolio/tech-stack/${id}`);
    return data;
  },

  restoreTechStack: async (id) => {
    const { data } = await api.patch(`/admin/portfolio/tech-stack/${id}/restore`);
    return data;
  },

  /* =====================================================
   SITE SETTINGS MANAGEMENT
===================================================== */

  getContact: async () => {
    const { data } = await api.get("/admin/contact");
    return data;
  },

  updateContact: async (payload) => {
    const { data } = await api.patch("/admin/contact", payload);
    return data;
  },
};

export default adminDashboardServices;
